export const processChange = (
  value: string | number,
  options: {
    showNegativeSign: boolean;
  },
) => {
  const {
    showNegativeSign = true,
  } = options;

  if (!showNegativeSign && value) {
    return String(value).replace(/^-/, '');
  }

  return value;
};
